export default __webpack_public_path__ + "static/img/vogue_scene_animated_0208.43fa90a.webp";